import type { ClockPort, TicketConnectResult, TicketPort } from '../domain/ports'
import { systemClock } from './runtime'

export class LocalTicketAdapter implements TicketPort {
  private online = true
  private readonly clock: ClockPort

  constructor(clock: ClockPort = systemClock) {
    this.clock = clock
  }

  setOnline(online: boolean): void {
    this.online = online
  }

  async connect(
    rawCode: string,
    userId: string,
    existing: Parameters<TicketPort['connect']>[2],
    showId: string,
  ): Promise<TicketConnectResult> {
    if (!this.online) {
      return { ok: false, code: 'ticket_offline', message: 'Reconnect to check this ticket code.' }
    }

    const normalized = rawCode.trim()
    if (!normalized) return { ok: false, code: 'ticket_invalid', message: 'Enter a ticket code.' }

    const alreadyConnected = existing.find((ticket) => ticket.showId === showId && ticket.status === 'connected')
    if (alreadyConnected) return { ok: true, ticket: alreadyConnected }

    // This local build deliberately accepts every non-empty value. No part of the
    // submitted value (or a reversible derivative) is copied into persisted state.
    const localProofId = `local-access-${showId}`

    return {
      ok: true,
      ticket: {
        id: `ticket-${userId}-${showId}`,
        fixtureId: localProofId,
        showId,
        lastFour: '0000',
        status: 'connected',
        section: 'GENERAL',
        row: 'GA',
        seat: 'OPEN',
        connectedAt: this.clock.now().toISOString(),
      },
    }
  }
}
